import React from 'react';
import { ThemeProvider as NextThemesProvider } from 'next-themes';

export function ThemeProvider({ children, ...props }: React.ComponentProps<typeof NextThemesProvider>) {
  return (
    <NextThemesProvider
      disableTransitionOnChange
      attribute="class"
      forcedTheme="light"
      defaultTheme="light"
      enableSystem={false}
      {...props}>
      {children}
    </NextThemesProvider>
  );
}
